export default __webpack_public_path__ + "static/media/Permanent Travelling Merchant Contract.a6639ca1.jpg";